import {
    CREATE_USER_PRODUCT_MEMBERSHIP,
    CREATE_USER_PRODUCT_MEMBERSHIP_FAILURE,
    DELETE_USER_PRODUCT_MEMBERSHIP,
    DELETE_USER_PRODUCT_MEMBERSHIP_FAILURE,
    DELETE_USER_PRODUCT_MEMBERSHIP_SUCCESS,
    FETCH_USER_PRODUCT_MEMBERSHIP,
    FETCH_USER_PRODUCT_MEMBERSHIP_FAILURE,
    FETCH_USER_PRODUCT_MEMBERSHIP_SUCCESS,
    FETCH_USER_PRODUCT_MEMBERSHIPS,
    FETCH_USER_PRODUCT_MEMBERSHIPS_FAILURE,
    FETCH_USER_PRODUCT_MEMBERSHIPS_SUCCESS,
    SORT_DESC,
    UPDATE_USER_PRODUCT_MEMBERSHIP,
    UPDATE_USER_PRODUCT_MEMBERSHIP_FAILURE,
    UPDATE_USER_PRODUCT_MEMBERSHIP_SUCCESS,
} from 'store/actions/types';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';
import { omit, size } from 'lodash';

const initialState = {
    data: {},
    field: 'name',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    ids: [],
    loading: false,
    offset: 0,
    order: SORT_DESC,
    page: 1,
    size: 24,
    total: 0,
};

export default (state = initialState,
    action) => {
    switch (action.type) {

        case FETCH_USER_PRODUCT_MEMBERSHIPS:
        case FETCH_USER_PRODUCT_MEMBERSHIP:
        case CREATE_USER_PRODUCT_MEMBERSHIP:
        case DELETE_USER_PRODUCT_MEMBERSHIP:
        case UPDATE_USER_PRODUCT_MEMBERSHIP:
            return {
                ...state,
                loading: true,
            };
        case FETCH_USER_PRODUCT_MEMBERSHIPS_SUCCESS: {
            const responseData = utils.mapToObject(action.payload.results, (value) => {
                return value.id;
            });

            const data = { ...state.data, ...responseData };

            return {
                ...state,
                loading: false,
                data,
                total: action.payload.total,
                size: action.payload.size,
                offset: action.payload.offset,
                ids: Object.keys(data),
            };
        }
        case FETCH_USER_PRODUCT_MEMBERSHIP_SUCCESS: {
            const data = {
                ...state.data,
                [action.payload.id]: action.payload,
            };

            return {
                ...state,
                loading: false,
                data,
                total: size(data),
                ids: Object.keys(data),
            };
        }
        case DELETE_USER_PRODUCT_MEMBERSHIP_SUCCESS: {
            const data = omit(state.data, action.payload);

            return {
                ...state,
                loading: false,
                data,
                total: state.total ? state.total - 1 : state.total,
                size: state.size ? state.size - 1 : state.size,
                ids: Object.keys(data),
            };
        }
        case UPDATE_USER_PRODUCT_MEMBERSHIP_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: {
                    ...state.data,
                    [action.payload.id]: action.payload,
                },
            };
        }
        case FETCH_USER_PRODUCT_MEMBERSHIPS_FAILURE:
        case FETCH_USER_PRODUCT_MEMBERSHIP_FAILURE:
        case CREATE_USER_PRODUCT_MEMBERSHIP_FAILURE:
        case DELETE_USER_PRODUCT_MEMBERSHIP_FAILURE:
        case UPDATE_USER_PRODUCT_MEMBERSHIP_FAILURE:
            return {
                ...state,
                loading: false,
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/reducers/userProductMembershipsReducer.js